import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '@app/shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginPageComponent } from './Pages/login-page/login-page.component';
import {UserService} from "@app/services/user.service";
import {AuthGuardService} from "@app/services/auth.guard";
import {JwtHelperService, JwtModule} from "@auth0/angular-jwt";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RoleService} from "@app/services/role.service";
import {RoleGuard} from "@app/services/role.guard";
import { CapitalBudgetFilterComponent } from '@app/Components/eval-line-item-grid/capital-budget-filter/capital-budget-filter.component';

export function tokenGetter() {
  return localStorage.getItem("access_token");
}

@NgModule({
  providers: [
    UserService,
    AuthGuardService,
    RoleService,
    RoleGuard,
    JwtHelperService,
  ],
  declarations: [
    AppComponent,
    LoginPageComponent,
    CapitalBudgetFilterComponent
  ],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    AppRoutingModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
      }
    }),
    ReactiveFormsModule,
    FormsModule
  ],
    exports: [
    ],
  bootstrap: [
    AppComponent,
  ]
})
export class AppModule {
	constructor() {}
}
